import { render } from "./NewPublishPost.vue?vue&type=template&id=46d16c84&scoped=true"
import script from "./NewPublishPost.vue?vue&type=script&lang=js"
export * from "./NewPublishPost.vue?vue&type=script&lang=js"

import "./NewPublishPost.vue?vue&type=style&index=0&id=46d16c84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d16c84"]])

export default __exports__